import { render, staticRenderFns } from "./s200BrazilPrivacy.vue?vue&type=template&id=246bb331&scoped=true&"
import script from "./s200BrazilPrivacy.vue?vue&type=script&lang=js&"
export * from "./s200BrazilPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./s200BrazilPrivacy.vue?vue&type=style&index=0&id=246bb331&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246bb331",
  null
  
)

export default component.exports